module.exports = __webpack_public_path__ + "img/section3Card1logo3.5bba4eed.png";